import ChangePasswordDialog from "./ChangePasswordDialog";

export default ChangePasswordDialog;
